module.exports = __webpack_public_path__ + "img/img1.7afe2f81.png";